var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2622_8050)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "#346F98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "url(#paint0_linear_2622_8050)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3167 40.6234L34.625 38.9317L36.5281 36.9984L34.625 35.0952L36.3167 33.3734L38.25 35.3067L40.1531 33.3734L41.875 35.0952L39.9417 36.9984L41.875 38.9317L40.1531 40.6234L38.25 38.7202L36.3167 40.6234ZM23.75 38.2067C24.0924 38.2067 24.3793 38.0909 24.6109 37.8593C24.8425 37.6277 24.9583 37.3407 24.9583 36.9984C24.9583 36.656 24.8425 36.369 24.6109 36.1374C24.3793 35.9058 24.0924 35.79 23.75 35.79C23.4076 35.79 23.1207 35.9058 22.8891 36.1374C22.6575 36.369 22.5417 36.656 22.5417 36.9984C22.5417 37.3407 22.6575 37.6277 22.8891 37.8593C23.1207 38.0909 23.4076 38.2067 23.75 38.2067ZM23.75 40.6234C22.7431 40.6234 21.8872 40.2709 21.1823 39.5661C20.4774 38.8612 20.125 38.0053 20.125 36.9984C20.125 35.9914 20.4774 35.1355 21.1823 34.4307C21.8872 33.7258 22.7431 33.3734 23.75 33.3734C24.4951 33.3734 25.1748 33.5798 25.7891 33.9926C26.4033 34.4055 26.8514 34.9643 27.1333 35.6692C27.9187 35.4477 28.5582 35.0147 29.0516 34.3702C29.545 33.7258 29.7917 32.9907 29.7917 32.165V27.3317C29.7917 25.6602 30.3807 24.2354 31.5589 23.0572C32.737 21.8791 34.1618 21.29 35.8333 21.29H37.2229L35.3198 19.3869L37.0417 17.665L41.875 22.4984L37.0417 27.3317L35.3198 25.64L37.2229 23.7067H35.8333C34.8264 23.7067 33.9705 24.0591 33.2656 24.764C32.5608 25.4689 32.2083 26.3248 32.2083 27.3317V32.165C32.2083 33.6352 31.7351 34.9291 30.7885 36.0468C29.842 37.1645 28.6437 37.8543 27.1937 38.1161C26.9521 38.8612 26.5141 39.4654 25.8797 39.9286C25.2453 40.3918 24.5354 40.6234 23.75 40.6234ZM21.8167 26.1234L20.125 24.4317L22.0281 22.4984L20.125 20.5952L21.8167 18.8734L23.75 20.8067L25.6531 18.8734L27.375 20.5952L25.4417 22.4984L27.375 24.4317L25.6531 26.1234L23.75 24.2202L21.8167 26.1234Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2622_8050",
    x: 0.791667,
    y: 0.748047,
    width: 60.4167,
    height: 60.4167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.20833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.604167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2622_8050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2622_8050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2622_8050",
    x1: 31,
    y1: 0.748047,
    x2: 31,
    y2: 58.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanicon);
export default __webpack_public_path__ + "static/media/plan+icon.54ef5563ab94a85e592906d74ef491ae.svg";
export { ForwardRef as ReactComponent };